import React, { useState, useEffect } from "react";

export default function CursorGlow({ pos }) {
  const [trail, setTrail] = useState([]);

  useEffect(() => {
    // Add current position to trail
    setTrail(prev => {
      const newTrail = [...prev, { x: pos.x, y: pos.y, id: Date.now() }];
      // Keep only last 10 positions
      return newTrail.slice(-10);
    });
  }, [pos.x, pos.y]);

  return (
    <>
      {/* Trail effect */}
      {trail.map((point, index) => (
        <div
          key={point.id}
          className="cursor-trail"
          style={{
            left: point.x,
            top: point.y,
            opacity: (index + 1) / trail.length * 0.5,
            transform: `translate(-50%, -50%) scale(${(index + 1) / trail.length})`
          }}
        />
      ))}
      
      {/* Main cursor glow */}
      <div 
        className="cursor-glow-main" 
        style={{ 
          left: pos.x, 
          top: pos.y
        }} 
      />
      
      {/* Cursor dot */}
      <div 
        className="cursor-dot" 
        style={{ 
          left: pos.x, 
          top: pos.y
        }} 
      />
      
      {/* Cursor ring */}
      <div 
        className="cursor-ring" 
        style={{ 
          left: pos.x, 
          top: pos.y
        }} 
      />
    </>
  );
}
